import * as Sentry from '@sentry/react'
import type {
    ErrorContext,
    SDKBreadcrumb,
    SDKLog,
    SDKObservabilityConfig,
    SDKWarning,
} from 'proctoring-sdk/index'

export const createProctoringSentryObservability = (meta?: {
    tenant?: string
    referenceId?: string
    profile?: string
}): SDKObservabilityConfig => ({
    onException: (error: Error, context: ErrorContext) => {
        Sentry.withScope(scope => {
            scope.setTag('feature', 'proctoring')
            if (meta?.tenant) scope.setTag('proctoring.tenant', meta.tenant)
            if (meta?.referenceId) scope.setTag('proctoring.referenceId', meta.referenceId)
            if (meta?.profile) scope.setTag('proctoring.profile', meta.profile)
            scope.setContext('proctoring', {
                feature: context.feature,
                component: context.component,
                operation: context.operation,
                lifecycleStage: context.lifecycleStage,
                severity: context.severity,
                metadata: context.metadata,
                sdkVersion: context.sdkVersion,
            })
            Sentry.captureException(error)
        })
    },
    onBreadcrumb: (breadcrumb: SDKBreadcrumb) => {
        let message = 'proctoring'
        if (typeof breadcrumb.message === 'string') {
            message = breadcrumb.message
        } else if (typeof breadcrumb.category === 'string') {
            message = breadcrumb.category
        }
        Sentry.addBreadcrumb({
            category: 'proctoring',
            message,
            data: breadcrumb,
            level: 'info',
        })
    },
    onWarning: (warning: SDKWarning) => {
        Sentry.addBreadcrumb({
            category: 'proctoring',
            message: warning.message,
            data: {
                feature: warning.feature,
                component: warning.component,
                metadata: warning.metadata,
                sdkVersion: warning.sdkVersion,
            },
            level: 'warning',
        })
    },
    onLog: (log: SDKLog) => {
        Sentry.addBreadcrumb({
            category: 'proctoring',
            message: log.message,
            data: {
                feature: log.feature,
                component: log.component,
                metadata: log.metadata,
                sdkVersion: log.sdkVersion,
            },
            level: log.level === 'debug' ? 'debug' : 'info',
        })
    },
})
